import React from 'react';

import { IncludedFees } from 'components/IncludedFees/IncludedFees';
import { SelectedOfferFees as ConnectedSelectedOfferFees } from 'containers/SelectedOfferFees/SelectedOfferFees';

const SelectedOfferFees = () => (
  <ConnectedSelectedOfferFees render={fees => <IncludedFees fees={fees} />} />
);

export { SelectedOfferFees };
